var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonShortsClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7744 8.31682L12.5743 7.81682L14.0043 7.05682C15.8443 6.09682 16.5343 3.82682 15.5643 1.99682C14.5943 0.166817 12.3243 -0.533183 10.4943 0.436817L2.00435 4.93682C0.714347 5.61682 -0.0656524 6.97682 0.00434757 8.42682C0.0743476 9.84682 0.934347 11.0968 2.22435 11.6768C2.25435 11.6868 3.42435 12.1768 3.42435 12.1768L2.00435 12.9268C0.174347 13.8968 -0.525653 16.1668 0.444347 17.9968C1.41435 19.8268 3.68435 20.5268 5.51435 19.5568L14.0143 15.0568C15.3043 14.3768 16.0743 13.0168 16.0043 11.5668C15.9343 10.1468 15.0644 8.88682 13.7744 8.31682Z",
    fill: "#045ADC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00435 7.34683V12.6468L11.0043 9.99683L6.00435 7.34683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonShortsClick);
export default __webpack_public_path__ + "static/media/common-shorts-click.7f982c45eb1b226f82abe9274b571e66.svg";
export { ForwardRef as ReactComponent };